import React, { useEffect } from "react";

import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";

import { Grid } from "@material-ui/core";

import { APP_ROUTES, NEW_PATH_SELECTED } from "../../config/constants";
import BasicDetails from "../BasicDetails/BasicDetails";
import { selectUserDetails } from "../Login/redux/userSlice";
import ServiceAndSlots from "../ServiceAndSlots/ServiceAndSlots";

import createPOSStyles from "./CreatePOSStyles";
import SideBar from "./SideBar/SideBar";
import { getCurrentUrl } from "../../utils/ApplicationUtils";
import { isEmptyOrNull } from "../../utils/DataUtils";

const CreatePOS = () => {
  const classes = createPOSStyles();
  const userInfo = useSelector(selectUserDetails);

  useEffect(() => {
    const currentLocation = getCurrentUrl();
    if (!isEmptyOrNull(currentLocation)) {
      localStorage.setItem(NEW_PATH_SELECTED, currentLocation);
    }
  }, []);

  return (
    <Grid container spacing={0} className={classes.mainContentSection}>
      <Grid item xs={3} className={classes.sideBarContainer}>
        <SideBar userInfo={userInfo} />
      </Grid>
      <Grid item xs={9} className={classes.mainContent}>
        <Routes>
          <Route path={`${APP_ROUTES.BASIC_DETAILS}/:posNo?`} element={<BasicDetails />} />
          <Route path={`${APP_ROUTES.SERVICE_AND_SLOTS}/*`} element={<ServiceAndSlots />} />
        </Routes>
      </Grid>
    </Grid>
  );
};

export default CreatePOS;
